/**
 * Image slider at the top of the mobile menu drawer.
 * Slides scroll natively (CSS scroll-snap); this keeps the square pagination
 * dots in sync with the visible slide and lets them jump to a slide.
 */
class PaccDrawerBanner extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.dots = [...this.querySelectorAll('[data-dot]')];
    if (!this.track || this.dots.length < 2) return;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goTo(index));
    });
    this.track.addEventListener('scroll', this.#onScroll, { passive: true });
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.#onScroll);
    cancelAnimationFrame(this.frame);
  }

  /** @param {number} index */
  goTo(index) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
    this.track.scrollTo({
      left: index * this.track.clientWidth * direction,
      behavior: reduceMotion ? 'auto' : 'smooth',
    });
  }

  #onScroll = () => {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => {
      const width = this.track.clientWidth || 1;
      const active = Math.round(Math.abs(this.track.scrollLeft) / width);
      this.dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', index === active ? 'true' : 'false');
      });
    });
  };
}

if (!customElements.get('pacc-drawer-banner')) {
  customElements.define('pacc-drawer-banner', PaccDrawerBanner);
}
